<template>
  <div
    class="partners section"
    :style="sectionStyle"
  >
    <div class="container">
      <div class="q-gutter-lg text-center">
        <img
          v-for="(logo, index) in items"
          :key="index"
          :alt="logo"
          :src="logo"
          class="logo"
        >
      </div>

      <div
        v-if="description"
        :style="descriptionStyle"
        class="description q-my-lg q-mx-auto"
      >
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';

export default {
  name: 'PartnersSection',
  mixins: [backgroundMixin, descriptionMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.partners {
  .logo {
    height: 60px;
  }

  .description {
    text-align: center;
    max-width: 600px;
  }
}
</style>
